import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const firmKey: ServerColDef<InvestorFirmFragment> = {
  field: 'firmKey',
  headerName: 'Firm Key',
  initialWidth: 220,
};
